import {Injectable} from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import {CerbaAuthService} from "../../services/auth.service";

@Injectable()
export class LogoutAuthGuard implements CanActivate {

    constructor(private cerbaAuthService: CerbaAuthService, private router: Router) {
    }

    // TODO A supprimer pour la mise en production
    canActivate() {

        this.cerbaAuthService.logout();
        return false;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/guards/security/cerba-logout.guard.ts